module.exports = __webpack_public_path__ + "static/media/ToBeConverted.2ee53405.png";